import React from 'react';
import { 
  TextField, 
  Paper, 
  Typography, 
  Box
} from '@mui/material';
import { ProjectInfo } from '../types';

interface ProjectInfoProps {
  projectInfo: ProjectInfo;
  onProjectInfoChange: (info: ProjectInfo) => void;
}

const ProjectInfoComponent: React.FC<ProjectInfoProps> = ({ 
  projectInfo, 
  onProjectInfoChange 
}) => {
  const handleChange = (field: keyof ProjectInfo) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onProjectInfoChange({
      ...projectInfo,
      [field]: event.target.value
    });
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ 
        fontWeight: 'bold', 
        color: 'text.primary',
        mb: 2
      }}>
        Project Information
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <TextField
            fullWidth
            label="Date"
            value={projectInfo.date}
            onChange={handleChange('date')}
            variant="outlined"
            placeholder="Enter project date"
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <TextField
            fullWidth
            label="Project Summary"
            value={projectInfo.projectSummary}
            onChange={handleChange('projectSummary')}
            variant="outlined"
            placeholder="Enter project summary"
            multiline
            rows={2}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default ProjectInfoComponent; 